export const MAX_PAYMENT_CARDS = 6;

export const CARD_NAME_MAX_LENGTH = 14;

export const CardDataStat = {
  AddNewCard: 'add-new-user-card',
  RenameCard: 'rename-user-card',
  RemoveCard: 'remove-user-card',
  SetPrimaryCard: 'set-primary-card',
} as const;
